/*
 * tetris_logic.js: Ham Tetris (HT) logic. Check the GUI in tetris_gui.js
 *
 * LICENSE:
 * Copyright (c) 2013, Cyborg Evilham (http://cyborg.evilham.com)
 * BSD 2-Clause copyright and disclaimer apply.
 *
 */

const HT = {};

HT.board={
  active: [],
  rows: 0,
  columns: 0,
  isActivated:
    function(i,j) {
      return this.active.indexOf(this.genPair(i,j))!=-1;
    },
  activate:
    function(l,source) {
      var cblist=[];
      for (var k=0; k<l.length; ++k) {
        var i=l[k][0];
        var j=l[k][1];
        if (this.active.indexOf(this.genPair(i,j))==-1) {
          this.active[this.active.length]=this.genPair(i,j);
          cblist[cblist.length]=[i,j];
        }
      }
      if (cblist.length>0)
        this.internalCallback(cblist,true,source);
    },
  deactivate:
    function(l,source) {
      var cblist=[];
      for (var k=0; k<l.length; ++k) {
        var i=l[k][0];
        var j=l[k][1];
        var ind=this.active.indexOf(this.genPair(i,j));
        if (ind!=-1) {
          this.active.splice(ind,1);
          cblist[cblist.length]=[i,j];
        }
      }
      if (cblist.length>0)
        this.internalCallback(cblist,false,source);
    },
  toggle:
    function(l,source) {
      var cblistactive=[];
      var cblistinactive=[];
      for (var k=0; k<l.length; ++k) {
        var i=l[k][0];
        var j=l[k][1];
        var ind=this.active.indexOf(this.genPair(i,j));
        if (ind==-1) {
          this.active[this.active.length]=this.genPair(i,j);
          cblistactive[cblistactive.length]=[i,j]
        }
        else {
          this.active.splice(ind,1);
          cblistinactive[cblistinactive.length]=[i,j]
        }
      }
      if (cblistactive.length>0)
        this.internalCallback(cblistactive,true,source);
      if (cblistinactive.length>0)
        this.internalCallback(cblistinactive,false,source);
    },
  // To be implemented by a GUI or some logic layer + GUI
  // callback: update the graphic board / trigger events based on new positions.
  callback: function(l,newstate,source) {},
  // From here, should be private if possible
  genPair: function(i,j) { return "("+i+","+j+")";},
  sortFunction:
    function(i,j) {
      if (i[0]==j[0]) {
        if (i[1]==j[1])
          return 0;
        else
          return i[1]-j[1];
      }
      else
        return i[0]-j[0];
    },
  internalCallback:
    function(l,newstate,source){
      // Sort
      l.sort(this.sortFunction);
      this.active.sort(this.sortFunction);
      // Signal the GUI or logic layer the changes on the board.
      this.callback(l,newstate,source);
    },
  reset: function() {
    var l=[];
    for (var i=0; i<this.columns; ++i) {
      for (var j=0; j<this.rows; ++j) {
        l[l.length]=[i,j];
      }
    }
    this.callback(l,false);
    this.active=[];
  },
}
HT.gameplay={
  // Based on: http://tetris.wikia.com/wiki/Tetris_(Game_Boy)
  // trying to replicate the gameplay of 
  board: HT.board,
  piece: [],
  nextPiece: [],
  score: 0,
  lines: 0,
  startLevel: 4,
  level: 0,
  moveDown: function() {
    if (!this.waiting) {
      var goal=this.goalPiece(this.piece, [0,-1]);
      if (this.isMovementPossible(this.piece, goal))
        this.movePiece(goal);
      else
        this.pieceLocated();
    }
  },
  moveLeft: function() {
    if (!this.waiting) {
      var goal=this.goalPiece(this.piece, [-1,0]);
      if (this.isMovementPossible(this.piece, goal))
        this.movePiece(goal);
    }
  },
  moveRight: function() {
    if (!this.waiting) {
      var goal=this.goalPiece(this.piece, [1,0]);
      if (this.isMovementPossible(this.piece, goal))
        this.movePiece(goal);
    }
  },
  rotateClockwise: function() {
    if (!this.waiting) {
      var goal=this.goalPieceRotate(this.piece, 1);
      if (this.isMovementPossible(this.piece, goal))
        this.movePiece(goal);
    }
  },
  rotateCounterClockwise: function() {
    if (!this.waiting) {
      var goal=this.goalPieceRotate(this.piece, -1);
      if (this.isMovementPossible(this.piece, goal))
        this.movePiece(goal);
    }
  },
  //currentTimestep: 887,
  currentTimestep: function(){
      return 1000*this.framesPerRow[this.level]/this.gboyFPS;
    },
  timer: null,
  currentSoftDropTimestep: 296,
  softDropTimer: null,
  // To be implemented by the GUI:
  // lostCallback: inform the GUI that the game is over. Execute f to restart.
  lostCallback: function(f){f()},
  // boardCallback: update the graphic board
  boardCallback: function(l,newstate,source) {},
  // lineCallback:
  //   Nice! Finally some points. Animate the lines or something.
  //   Also, f triggers the actual removal of the lines + pseudo-gravity effect
  //   make sure your function calls it at the end of the animation!
  lineCallback: function(lines,f) {f();},
  // nextPieceCallback: tells the GUI that the next piece is something different
  nextPieceCallback: function(piece) {},
  // scoreCallback: tells the GUI that the score has changed.
  scoreCallback: function(lines,score,level){},

  // Private if possible
  startOfSoftDrop: 0,
  framesPerRow: [53,49,45,41,37,33,28,22,17,11,10,9,8,7,6,6,5,5,4,4,3],
  gboyFPS: 59.73,
  /*
  calcCurrentTimestep: function() {
    this.currentTimestep=1000*this.framesPerRow[this.level]/this.gboyFPS;
    return this.currentTimestep;
  },
  */
  calcCurrentSoftDropTimestep: function() {
    this.currentSoftDropTimestep=1000/this.gboyFPS*3;
    return this.currentSoftDropTimestep;
  },
  goalPiece: function(piece, delta) {
    var goal=[];
    for (var i=0; i<piece.length; ++i) {
      goal[i]=[piece[i][0]+delta[0],piece[i][1]+delta[1]];
    }
    return goal;
  },
  rotate: function(piece, base, angle) {
    //0=0º, 1=-90º,... increases clockwise 
    var matrix=[];
    var a=angle%4;
    if (a<0) a+=4;
    switch(a % 4) {
      case 1: //90º CW
        matrix=[0,1,-1,0];
        break;
      case 2: //180º
        matrix=[-1,0,0,-1];
        break;
      case 3: //270º CW
        matrix=[0,-1,1,0];
        break;
      default: //Identity
        matrix=[1,0,0,1];
    }
    var goal=[];
    for (var i=0; i<piece.length; ++i) {
      var x=piece[i][0]-base[0];
      var y=piece[i][1]-base[1];
      goal[i]=[];
      goal[i][0]=matrix[0]*x+matrix[1]*y+base[0];
      goal[i][1]=matrix[2]*x+matrix[3]*y+base[1];
    }
    return goal;
  },
  pieceCenter: function(piece) {
    c=[0,0];
    for (var i=0; i<piece.length; ++i) {
      c[0]+=piece[i][0];
      c[1]+=piece[i][1];
    }
    c[0]=Math.round(c[0]/piece.length);
    c[1]=Math.round(c[1]/piece.length);
    return c;
  },
  goalPieceRotate: function(piece, angle) {
    var c=this.pieceCenter(piece);
    var goal=this.rotate(piece, c, angle);
    var c2=this.pieceCenter(goal);
    return this.goalPiece(goal,[c[0]-c2[0],c[1]-c2[1]]);
  },
  movePiece: function(goal) {
    this.board.deactivate(this.piece);
    this.board.activate(goal);
    this.piece=goal;
  },
  isMovementPossible: function(piece, goal) {
    var pieceaux=[];
    for (var i=0; i<piece.length; ++i)
      pieceaux[i]=this.board.genPair(piece[i][0],piece[i][1]);
    var possible=true;
    for (var i=0; possible && i<goal.length; ++i) {
      if (pieceaux.length>0 &&
          (goal[i][0]<0 || goal[i][0]>=this.board.columns ||
          goal[i][1]<0 || goal[i][1]>=this.board.rows))
        possible=false;
      else{
        if (this.board.isActivated(goal[i][0],goal[i][1]) &&
            pieceaux.indexOf(this.board.genPair(goal[i][0],goal[i][1]))==-1)
          // if it's active and it doesn't belong to the current piece.
          possible=false;
      }
    }
    return possible;
  },
  generatePiece: function() {
    var pieces=
      [
      /*  X
       * XXX */
        [[0,0],[1,0],[1,1],[2,0]],
      /* XXXX */
        [[0,0],[1,0],[2,0],[3,0]],
      /*  XX
       * XX */
        [[0,0],[1,0],[1,1],[2,1]],
      /* XX 
       *  XX */
        [[0,1],[1,1],[1,0],[2,0]],
      /* XX 
       * XX */
        [[0,0],[0,1],[1,0],[1,1]],
      /* X 
       * XXX */
        [[0,1],[0,0],[1,0],[2,0]],
      /*   X
       * XXX */
        [[0,0],[1,0],[2,0],[2,1]],
      ];
    var type=Math.floor(Math.random()*pieces.length);
    var angle=Math.floor(Math.random()*pieces.length);
    var c=this.pieceCenter(pieces[type]);
    var boardtop=[Math.floor(this.board.columns/2),this.board.rows-2];
    var goal=this.goalPiece(this.goalPieceRotate(pieces[type],angle), 
        [boardtop[0]-c[0], boardtop[1]-c[1]]);
    return goal;
  },
  pieceLocated: function() {
    if (!this.checkLost(this.piece)) {
      this.stopTimer();
      this.waiting=true;
      this.checkLines(this.piece);
    }
  },
  internalBoardCallback:
    function(scope){
      return function(l,newstate,source) {
        // Signal the GUI the changes on the board.
        scope.boardCallback(l,newstate,source);
      };
    },
  internalLineCallback:
    function(lines) {
      // Remove the lines
      lines.sort().reverse();
      for (var l=0; l<lines.length; ++l) {
        // Start at the end of the array (topmost line).
        var j=lines[l];
        // clear line
        var larray=[];
        for (var i=0; i<this.board.columns; ++i) {
          larray[larray.length]=[i,j];
        }
        this.board.deactivate(larray);
        // pseudo-gravity, move things down.
        for (var k=j+1; k<this.board.rows; ++k) {
          var toact=[];
          var todeact=[];
          for (var i=0; i<this.board.columns; ++i) {
            if (this.board.isActivated(i,k)&&!this.board.isActivated(i,k-1)) {
              todeact[todeact.length]=[i,k];
              toact[toact.length]=[i,k-1];
            }
          }
          this.board.deactivate(todeact);
          this.board.activate(toact);
        }
        //potential callback to GUI  for a pause in falling :-)
      }
      if (this.softDropTimer) {
          this.score+=this.startOfSoftDrop-this.pieceCenter(this.piece)[1];
      }
      if (lines.length>0) {
        var points=[40,100,300,1200];
        this.score+=points[lines.length-1]*(this.level+1);
        this.lines+=lines.length;
        this.level=this.startLevel+Math.floor(this.lines/10);
      }
      if (this.score>999999) this.score=999999; //classic
      this.scoreCallback(this.lines,this.score,this.level);
      // update the pieces
      this.piece=this.nextPiece;
      if (this.isMovementPossible([],this.piece)) {
        this.nextPiece=this.generatePiece();
        this.startTimer();
        this.waiting=false;
        this.nextPieceCallback(this.nextPiece);
      }
      else {
        this.lost();
      }
      this.board.activate(this.piece);
    },
  checkLines:
    function(l) { // here l is the piece that can't move down further.
      // Check for lines!
      var lines=[];
      var checkedLines=[];
      for (var i=0; i<l.length; ++i) {
        if (checkedLines.indexOf(l[i][1])==-1) { // don't check twice same line
          var line=true;
          for (var k=0; line && k<this.board.columns; ++k) {
            if (!this.board.isActivated(k,l[i][1])) line=false;
          }
          checkedLines[checkedLines.length]=l[i][1];
          if (line)
            lines[lines.length]=l[i][1];
        }
      }
      // Signal the GUI the lines that are to be removed.
      this.lineCallback(lines,
          (function(scope){
            return function(){scope.internalLineCallback(lines);}
          })(this)
      );
  },
  lost: function() {
      // Signal the GUI that the game is over.
      this.waiting=true;
      this.lostCallback(
          (function(scope){
            return function(){scope.restart();}
          })(this)
      );
      this.stopTimer();
  },
  checkLost: function(piece) {
    //Called when piece stops falling.
    lost=false;
    for (var i=0; !lost && i<piece.length; ++i) {
      if (piece[i][1]>=this.board.rows) //piece still out of board
        lost=true;
    }
    if (lost) {
      this.lost();
    }
    return lost;
  },
  start:
    function(rows, columns,startLevel) {
      this.board.rows=rows;
      this.board.columns=columns;
      this.board.callback=this.internalBoardCallback(this);
      if (startLevel)
        this.startLevel=startLevel;
      this.restart();
    },
  restart: function(){
    this.score=0;
    this.lines=0;
    this.level=this.startLevel;
    this.calcCurrentSoftDropTimestep();
    this.board.reset();
    this.piece=this.generatePiece();
    this.board.activate(this.piece);
    this.nextPiece=this.generatePiece();
    this.nextPieceCallback(this.nextPiece);
    this.scoreCallback(this.lines,this.score,this.level);
    this.board.activate(this.piece);
    //start clock
    this.waiting=false;
    this.startTimer();
  },
  startTimer: function() {
    if (this.timer)
      this.stopTimer(); 
    this.timer=setInterval(
        (function(scope){
          return function(){scope.moveDown();}
        }(this)),this.currentTimestep());
  },
  stopTimer: function() {
    window.clearInterval(this.timer);
    this.timer=null;
  },
  startSoftDropTimer: function() {
    if (this.softDropTimer)
      this.stopSoftDropTimer(); 
    this.startOfSoftDrop=this.pieceCenter(this.piece)[1];
    this.softDropTimer=setInterval(
        (function(scope){
          return function(){scope.moveDown();}
        }(this)),this.currentSoftDropTimestep);
  },
  stopSoftDropTimer: function() {
    this.startOfSoftDrop=0;
    window.clearInterval(this.softDropTimer);
    this.softDropTimer=null;
  },
}

module.exports = HT;
